<template>
    <common-chart :chart-id="chartId" :options="config"></common-chart>
</template>

<script>
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart";

export default {
    name: "ProductionCosts",
    components: {CommonChart},
    props: {
        chartId: String,
    },
    computed: {
        config() {
            return {
                legend: {},
                tooltip: {},
                xAxis: [
                    {
                        type: 'category',
                        gridIndex: 0,
                        data: this.labels(this.materialCost),
                        axisLabel: {
                            color: '#ddd'
                        },
                    },
                    {
                        type: 'category',
                        gridIndex: 1,
                        data: this.labels(this.energyCost),
                        axisLabel: {
                            color: '#ddd'
                        },
                    }
                ],
                yAxis: [{gridIndex: 0}, {gridIndex: 1}],
                grid: [{bottom: '55%'}, {top: '55%'}],
                series: [
                    // These series are in the first grid.
                    {
                        type: 'bar',
                        data: this.values(this.materialCost)
                    },
                    // These series are in the second grid.
                    {
                        type: 'bar', xAxisIndex: 1, yAxisIndex: 1,
                        data: this.values(this.energyCost)
                    },
                ]
            };
        }
    },
    data() {
        return {
            materialCost: [
                {label: 'material1', value: 15},
                {label: 'material2', value: 80},
                {label: 'material3', value: 40},
                {label: 'material4', value: 20},
                {label: 'material5', value: 100},
                {label: 'material6', value: 15},
                {label: 'material7', value: 50},
                {label: 'material8', value: 85},
                {label: 'material9', value: 30},
                {label: 'material10', value: 23},
                {label: 'material11', value: 3},
            ],
            energyCost: [
                {label: 'energy1', value: 15},
                {label: 'energy2', value: 80},
                {label: 'energy3', value: 20},
                {label: 'energy4', value: 50},
                {label: 'energy5', value: 37},
                {label: 'energy6', value: 48},
            ]
        }
    },
    methods: {

        labels(source) {
            let tempList = [];
            source.forEach(o => tempList.push(o.label));
            return tempList;
        },
        values(source) {
            let tempList = [];
            source.forEach(o => tempList.push(o.value));
            return tempList;
        },
    }
}
</script>

<style scoped>

</style>